import client from "../utils/ApiHelper.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchAllPrivilege() {
    try {
        let res = await client.get("/privilege");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchOnePrivilege(id) {
    try {
        let res = await client.get("/privilege/privilege_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchControlListByPrivilege(id) {
    try {
        let res = await client.get("/control-list/privilege_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function updateControlListByPrivilege(privilege_id, action_page_id) {
    try {
        let res = await client.post("/control-list/update", {
            privilege_id: privilege_id,
            action_page_id: action_page_id
        });

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function createPrivilege(name) {
    try {
        let res = await client.post("/privilege/create", {
            name: name
        });

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function updatePrivilege(id, name) {
    try {
        let res = await client.post("/privilege/update", {
            id: id,
            name: name
        });

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function deletePrivilege(id) {
    try {
        let res = await client.delete("/privilege/privilege_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

export {
    fetchAllPrivilege,
    fetchOnePrivilege,
    fetchControlListByPrivilege,
    updateControlListByPrivilege,
    createPrivilege,
    updatePrivilege,
    deletePrivilege,
};
